// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    overflow: visible !important;
    border: none !important;
}

.menu-container {
    display: none;
    width: max-content;
    top: 30px;
    left: 0;
    padding: 5px;
    margin: 0;
    background: #fff;
    border: 1px solid #6E7079;
    position: absolute;
}

.menu-container.active {
    display: block;
}
`, "",{"version":3,"sources":["webpack://./src/controls/common/menu/index.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[":host {\r\n    overflow: visible !important;\r\n    border: none !important;\r\n}\r\n\r\n.menu-container {\r\n    display: none;\r\n    width: max-content;\r\n    top: 30px;\r\n    left: 0;\r\n    padding: 5px;\r\n    margin: 0;\r\n    background: #fff;\r\n    border: 1px solid #6E7079;\r\n    position: absolute;\r\n}\r\n\r\n.menu-container.active {\r\n    display: block;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
